<template>
    <div>
        <div class="pt-2 px-4">
            <div v-if="transportExtrasArray.length > 0" class="bg-lightest radius-normal border-light my-4 py-3 px-4 d-flex flex-column">
                <transport-selector :reservation="reservation"></transport-selector>
            </div>
        </div>

        <div class="px-4">
            <div v-if="reservation.event.eventRoutes.length > 0 || transportExtrasArray.length > 0" class="bg-lightest radius-normal border-light my-4 py-3 px-3 d-flex flex-column">
                <route-form :routes="getAllRoutes" :reservation="reservation" title="Pick up location" :transportList="transportExtrasArray" :type="1"></route-form>
            </div>

            <div v-else class="bg-lightest radius-normal border-light d-flex my-4 px-3">
                <div class="text-center dark fs-largest pt-4 text-center mb-4 w-100">
                    This event has no transportation available
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    import RouteForm from './AddTransport/RouteForm'
    import TransportSelector from './AddTransport/TransportSelector'

    export default {
        data() {
            return {
                transportExtrasArray: [],
            }
        },
        props: {
            reservation: {
                type: Object
            }
        },
        created() {
            // Filter to get only components type 1 (transports)
            this.transportExtrasArray = this.reservation.event.eventComponents.filter((event) => event.component.componentType === 1);
        },
        computed: {
            ...mapGetters([
                'account',
                'getAllRoutes'
            ])
        },
        methods: {
            hasTransportChanged(e) {
                if (e.value == false) {
                    this.reservation.transport.transfers = [];
                    this.createNumberOfTransfers();
                }
            }
        },
        components: {
            RouteForm,
            TransportSelector,
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// AddTransport.vue?27f1db99